import { IStoreState } from '../types';

export const getBrandsList = (state: IStoreState) => state.userBrands;
